module.exports = __webpack_public_path__ + "img/twitter.830367f8.svg";